/**
 * Copy for the book-finished flow (celebration → rating → kept → next), EN / SK / CS.
 * Counted keys carry the forms chosen explicitly by `bookSharePluralForm`
 * (the native runtime can lack Intl.PluralRules). Page and day counts reuse
 * `bookShare.finished.pages_*` / `days_*` so the sheet and the image agree.
 */
export const bookFinishCopy = {
  en: {
    eyebrow: 'Finished',
    close: 'Close',
    steps: 'Step {{current}} of {{total}}',
    momentLabel: 'You finished {{title}}',
    readOn_one: 'read on {{count}} day',
    readOn_few: 'read on {{count}} days',
    readOn_many: 'read on {{count}} days',
    readOn_other: 'read on {{count}} days',
    finishedOn: 'Finished on {{date}}',
    legendRead: 'reading day',
    legendFinish: 'finished',
    calendarLabel: 'Reading from {{start}} to {{end}}, progress recorded on {{count}} days',
    earlierWeeks: '+{{count}} earlier weeks',
    yearBook: 'Book {{count}} this year',
    yearGoal: 'goal {{target}}',
    share: 'Share',
    rate: 'Rate the book',
    ratingTitle: 'How did you like it?',
    ratingWord: {
      1: 'Weak',
      2: 'Not great',
      3: 'Good',
      4: 'Great',
      5: 'A favourite',
    },
    reviewLabel: 'Review',
    publicNote:
      'Reviews appear to other readers after approval. You can change yours any time in the book’s details.',
    privateNote: 'Reviews of books you added yourself stay private.',
    publish: 'Share with other readers',
    publishBody: 'After approval, under your reader name',
    skip: 'Skip',
    saveRating: 'Save rating',
    keptNext: 'What to read next',
  },
  sk: {
    eyebrow: 'Dočítané',
    close: 'Zavrieť',
    steps: 'Krok {{current}} z {{total}}',
    momentLabel: 'Dočítané: {{title}}',
    readOn_one: 'čítanie v {{count}} dni',
    readOn_few: 'čítanie v {{count}} dňoch',
    readOn_many: 'čítanie v {{count}} dňoch',
    readOn_other: 'čítanie v {{count}} dňoch',
    finishedOn: 'Dočítané {{date}}',
    legendRead: 'deň s čítaním',
    legendFinish: 'dočítané',
    calendarLabel: 'Čítanie od {{start}} do {{end}}, pokrok zaznamenaný v {{count}} dňoch',
    earlierWeeks: '+{{count}} skorších týždňov',
    yearBook: '{{count}}. kniha tento rok',
    yearGoal: 'ročný cieľ {{target}}',
    share: 'Zdieľať',
    rate: 'Ohodnotiť knihu',
    ratingTitle: 'Ako sa ti páčila?',
    ratingWord: {
      1: 'Slabá',
      2: 'Nič moc',
      3: 'Dobrá',
      4: 'Výborná',
      5: 'Srdcovka',
    },
    reviewLabel: 'Recenzia',
    publicNote:
      'Recenzia sa po schválení zobrazí ostatným čitateľom. Kedykoľvek ju zmeníš v detaile knihy.',
    privateNote: 'Recenzie vlastných kníh zostávajú súkromné.',
    publish: 'Zverejniť pre ostatných čitateľov',
    publishBody: 'Po schválení, pod tvojím čitateľským menom',
    skip: 'Preskočiť',
    saveRating: 'Uložiť hodnotenie',
    keptNext: 'Čo čítať ďalej',
  },
  cs: {
    eyebrow: 'Dočteno',
    close: 'Zavřít',
    steps: 'Krok {{current}} z {{total}}',
    momentLabel: 'Dočteno: {{title}}',
    readOn_one: 'čtení v {{count}} dni',
    readOn_few: 'čtení v {{count}} dnech',
    readOn_many: 'čtení v {{count}} dnech',
    readOn_other: 'čtení v {{count}} dnech',
    finishedOn: 'Dočteno {{date}}',
    legendRead: 'den se čtením',
    legendFinish: 'dočteno',
    calendarLabel: 'Čtení od {{start}} do {{end}}, pokrok zaznamenaný v {{count}} dnech',
    earlierWeeks: '+{{count}} dřívějších týdnů',
    yearBook: '{{count}}. kniha letos',
    yearGoal: 'roční cíl {{target}}',
    share: 'Sdílet',
    rate: 'Ohodnotit knihu',
    ratingTitle: 'Jak se ti líbila?',
    ratingWord: {
      1: 'Slabá',
      2: 'Nic moc',
      3: 'Dobrá',
      4: 'Výborná',
      5: 'Srdcovka',
    },
    reviewLabel: 'Recenze',
    publicNote:
      'Recenze se po schválení zobrazí ostatním čtenářům. Kdykoli ji změníš v detailu knihy.',
    privateNote: 'Recenze vlastních knih zůstávají soukromé.',
    publish: 'Zveřejnit pro ostatní čtenáře',
    publishBody: 'Po schválení, pod tvým čtenářským jménem',
    skip: 'Přeskočit',
    saveRating: 'Uložit hodnocení',
    keptNext: 'Co číst dál',
  },
} as const;
